import { Banner } from './Banner'
import { BannerVariant } from './banner.d'
import { useAnnouncementBanner } from 'hooks/useAnnouncementBanner'
import { ClinicAnnouncementType } from 'apis/contentful'

const VARIANT_MAP: Record<ClinicAnnouncementType, BannerVariant> = {
	info: BannerVariant.INFO,
	warn: BannerVariant.WARN,
	error: BannerVariant.ERROR
}

export const AnnouncementBanner = () => {
	const announcement = useAnnouncementBanner()

	if (!announcement) return null

	return (
		<Banner
			title={announcement.title}
			subtitle={announcement.text}
			variant={announcement.type ? VARIANT_MAP[announcement.type] : VARIANT_MAP['info']}
			href={announcement.link}
			linkTarget="_blank"
			buttonTitle={announcement.linkName}
			showButton={announcement.link ? true : false}
			bannerSx={{
				margin: '10px'
			}}
		/>
	)
}
